export enum INVITATON_TYPES {
  brand = 'brandinvite',
  creator = 'creatorinvite',
  agencyAdmin = 'agencyadmininvite',
}
